export default __webpack_public_path__ + "static/media/pictogramBeaconEatingOut40.cde3cdab.svg";